import { api } from "@/builders/axios";

export function resend_otp(data: { email: string }) {
  return api.post("/auth/signup/resend-otp", data);
}
